// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lmqF","top":"styles_top__zHn98"};